import React, {
  FC,
  SelectHTMLAttributes,
  Dispatch,
  SetStateAction,
} from 'react';
import { RegularSelect } from './RegularSelect';
import { MultiSelect } from './MultiSelect';
import { MultiSearchSelect } from './MultiSearchSelect';

type OptionType = {
  name: string;
  value: string;
};

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  selectLabel: string;
  multiselect?: boolean;
  multiSearchSelect?: boolean;
  options: OptionType[];
  width?: 'full' | 'lg' | 'md';
  positioning?: 'relative' | 'absolute';
  selectedOption?: OptionType;
  setSelectedOption?: Dispatch<SetStateAction<OptionType>>;
  selectedOptions?: OptionType[];
  setSelectedOptions?: Dispatch<SetStateAction<OptionType[]>>;
  onChange?: any;
  errors?: any;
  name?: string;
  withLabel?: boolean;
  isValid?: boolean;
  errorMessage?: string;
  largeHeight?: boolean;
  disabled?: boolean;
  cleared?: boolean;
  setCleared?: Dispatch<SetStateAction<boolean>>;
  maximum?: number;
  disableSelectAll?: boolean;
  pillVariant?: boolean;
}

export const Select: FC<SelectProps> = ({
  className,
  selectLabel,
  multiselect = false,
  multiSearchSelect = false,
  options = [],
  positioning,
  selectedOption = { name: '', value: '' },
  setSelectedOption,
  selectedOptions = [],
  setSelectedOptions,
  setCleared,
  width,
  onChange,
  errors,
  name,
  withLabel,
  isValid = true,
  errorMessage,
  largeHeight,
  disabled,
  cleared,
  maximum,
  disableSelectAll,
  pillVariant,
}: SelectProps) => {
  const renderRegularSelect = !multiselect && !multiSearchSelect && (
    <RegularSelect
      className={className}
      selectLabel={selectLabel}
      options={options}
      positioning={positioning}
      selectedOption={selectedOption}
      setSelectedOption={setSelectedOption}
      width={width}
      onChange={onChange}
      errors={errors}
      name={name}
      withLabel={withLabel}
      isValid={isValid}
      errorMessage={errorMessage}
      largeHeight={largeHeight}
      disabled={disabled}
      cleared={cleared}
      setCleared={setCleared}
      pillVariant={pillVariant}
    />
  );

  const renderMultiSelect = multiselect && !multiSearchSelect && (
    <MultiSelect
      className={className}
      selectLabel={selectLabel}
      options={options}
      positioning={positioning}
      selectedOptions={selectedOptions}
      setSelectedOptions={setSelectedOptions}
      width={width}
      onChange={onChange}
      errors={errors}
      name={name}
      withLabel={withLabel}
      isValid={isValid}
      errorMessage={errorMessage}
      largeHeight={largeHeight}
      disabled={disabled}
      maximum={maximum}
    />
  );

  const renderMultiSearchSelect = !multiselect && multiSearchSelect && (
    <MultiSearchSelect
      className={className}
      selectLabel={selectLabel}
      options={options}
      positioning={positioning}
      selectedOptions={selectedOptions}
      setSelectedOptions={setSelectedOptions}
      width={width}
      onChange={onChange}
      errors={errors}
      name={name}
      withLabel={withLabel}
      isValid={isValid}
      errorMessage={errorMessage}
      largeHeight={largeHeight}
      disabled={disabled}
      maximum={maximum}
      disableSelectAll={disableSelectAll}
    />
  );

  return (
    <>
      {renderRegularSelect}
      {renderMultiSelect}
      {renderMultiSearchSelect}
    </>
  );
};
